import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOpenaigymComponent } from './simple-icons-openaigym.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOpenaigymComponent ],
    exports:      [ SimpleIconsOpenaigymComponent ],
    bootstrap:    []
})
export class SimpleIconsOpenaigymModule {}
